import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AdmissionService } from "src/app/services/admission.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { MenuService } from "src/app/services/menu.service";
import { Orientation } from "../../../model/orientation/orientation";
import { PatientSearch } from "../../../model/patient/patient-search";
import { PatientService } from "../../../services/patient.service";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { OrientationService } from "../../../services/orientation.service";
import { PdfService } from "../../../services/pdf.service";
import Swal from "sweetalert2";
import { PatientReservationSector } from "../../../model/patient/patient-reservation-sector";
import { ServiceFilter } from "../../../model/service-filter";
import { ReservationService } from "../../../services/reservation.service";
import { NotificationToastService } from "../../../services/notification-toast.service";

export interface Month {
  value: number;
  name: string;
}

@Component({
  selector: "app-orientation-patient",
  templateUrl: "./orientation-patient.component.html",
  styleUrls: ["./orientation-patient.component.css"],
  animations: [
    // the fade-in/fade-out animation.
    trigger("simpleFadeAnimation", [
      // the "in" style determines the "resting" state of the element when it is visible.
      state("in", style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(":enter", [style({ opacity: 0 }), animate(1000)]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(":leave", animate(0, style({ opacity: 0 }))),
    ]),
    trigger("blockAnimation", [
      state(
        "botton",
        style({
          transform: "translateY(400px)",
        })
      ),
      state(
        "top",
        style({
          transform: "translateY(0px)",
        })
      ),
      state(
        "left",
        style({
          transform: "translateX(-50px)",
        })
      ),
      state(
        "right",
        style({
          transform: "translateX(50px)",
        })
      ),
      transition("* => top", [animate("5s ease-in")]),
      transition("* => left", [animate("5s ease-in")]),
      transition("* => right", [animate("5s ease-in")]),
      transition("* => botton", [animate("5s ease-in")]),
    ]),
  ],
})
export class OrientationPatientComponent implements OnInit {
  @ViewChild("qrInput", { static: false }) qrInput: ElementRef;

  medicalAppointmentIds: number[] = [];
  loadingAction: boolean;
  loading: boolean;
  patientDocument: string;
  birthDay: string;
  birthMonth: string;
  birthYear: string;
  qrCode: string = "";
  qrIsHidden = true;
  orientation: Orientation;
  logo: SafeUrl;
  patients: PatientSearch[] = [];
  selectedDayValue: number;
  selectedMonthValue: number;
  selectedYearValue: number;
  serviceId?: number;
  disabilityTemporal: boolean;
  services: ServiceFilter[];
  otherReservationsText: string[];
  patientReservationSector: PatientReservationSector[] = [];
  state = "botton";

  block: boolean;
  document: boolean;
  birthDate: boolean;
  action: boolean;
  otherReservation: boolean;
  service: boolean;

  dates: number[] = [];
  years: number[] = [];
  months: Month[] = [
    { value: 1, name: "Enero" },
    { value: 2, name: "Febrero" },
    { value: 3, name: "Marzo" },
    { value: 4, name: "Abril" },
    { value: 5, name: "Mayo" },
    { value: 6, name: "Junio" },
    { value: 7, name: "Julio" },
    { value: 8, name: "Agosto" },
    { value: 9, name: "Septiembre" },
    { value: 10, name: "Octubre" },
    { value: 11, name: "Noviembre" },
    { value: 12, name: "Diciembre" },
  ];

  constructor(
    private route: ActivatedRoute,
    private admissionService: AdmissionService,
    private reservationService: ReservationService,
    private patientService: PatientService,
    private notificationToastService: NotificationToastService,
    private sanitizer: DomSanitizer,
    private orientationService: OrientationService,

    private pdfService: PdfService,
    menuService: MenuService
  ) {
    menuService.hideMenu();
  }

  setDisabilityTemporal() {
    this.disabilityTemporal = !this.disabilityTemporal;
  }

  ngOnInit() {
    this.loading = true;
    this.route.params.subscribe(async (params) => {
      this.goStart();
      this.loadDates();
      this.loadYears();
      const id = params["Id"];
      this.orientation = await this.admissionService.getOrientation(id);
      const objectURL = "data:image/jpeg;base64," + this.orientation.LogoBase64;
      this.logo = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.loading = false;
    });
  }

  animationBlock($event) {
    if (this.state === "top") {
      this.state = "botton";
    } else if (this.state === "botton") {
      this.state = "left";
    } else if (this.state === "left") {
      this.state = "right";
    } else if (this.state === "right") {
      this.state = "botton";
    }
  }

  loadYears() {
    const today = new Date();
    for (let i = today.getFullYear(); i >= today.getFullYear() - 150; i--) {
      this.years.push(i);
    }
  }

  loadDates() {
    for (let i = 1; i < 32; i++) {
      this.dates.push(i);
    }
  }

  getPatientName() {
    if (this.patients && this.patients.length === 1) {
      return `${this.patients[0].LastName}, ${this.patients[0].FirstName}`;
    } else {
      return "";
    }
  }

  yesPatient() {
    this.goDocument();
  }

  async birthDateNext() {
    if (
      this.selectedDayValue > 0 &&
      this.selectedMonthValue > 0 &&
      this.selectedYearValue > 0
    ) {
      this.patients = this.patients.filter(
        (p) =>
          p.BirthDate === this.selectedDayValue &&
          p.BirthMonth === this.selectedMonthValue &&
          p.BirthYear === this.selectedYearValue
      );
      await this.goAction();
    }
  }

  birthDateBack() {
    this.goDocument();
  }

  serviceBack() {
    this.goStart();
  }

  serviceNext(service: ServiceFilter) {
    this.serviceId = service.Id;
    this.printAdmission();
  }

  documentBack() {
    this.goStart();
  }

  notPatient() {
    this.goAction();
  }

  cancel() {
    this.goStart();
  }

  unBlock() {
    this.goStart();
  }

  // @HostListener('document:keypress', ['$event'])
  async onKey(event: KeyboardEvent) {
    if (event.key !== "Enter") {
      this.qrCode += event.key;
    }

    if (event.key === "Enter") {
      try {
        this.loadingAction = true;
        const data = await this.patientService.getPatientsByQr(this.qrCode);

        this.patients = data.Patient ? [data.Patient] : [];

        if (this.patients.length == 0) {
          this.notificationToastService.info("Paciente no encontrado", "QR");
        }

        this.qrCode = "";
        await this.goAction();
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), "QR");
      } finally {
        this.loadingAction = false;
      }
    }

    this.qrInput.nativeElement.focus();
  }

  setNumber(num: string): void {
    this.patientDocument = this.patientDocument + num;
    this.qrInput.nativeElement.focus();
  }

  clear(): void {
    this.patientDocument = "";
    this.qrInput.nativeElement.focus();
  }

  async documentNext() {
    if (this.patientDocument !== "") {
      const data = await this.patientService.getPatientsByParameters(
        this.patientDocument,
        "",
        ""
      );
      this.patients = data;

      if (data.length === 1 || data.length === 0) {
        await this.goAction();
      } else {
        this.goBirthDate();
      }
    }
  }

  private async getAppointmentsByAutomaticAdmission(
    patientId: number
  ): Promise<number[]> {
    return await this.reservationService.getAppointmentsByAutomaticAdmission(
      this.orientation.Id,
      patientId
    );
  }

  private async findAndSetTextOthersReservation(patientId: number) {
    this.otherReservationsText = [];
    this.patientReservationSector =
      await this.patientService.getPatientReservationSectorNotInOrientation(
        this.orientation.Id,
        patientId
      );

    if (this.patientReservationSector.length > 0) {
      this.patientReservationSector.forEach((item) => {
        this.otherReservationsText.push(`- ${item.CenterName}
                                        , sector ${item.SectorName}
                                        en el horario ${item.ReservationDate}`);
      });
    }
  }

  async printAdmission() {
    try {
      this.loadingAction = true;
      let patientId = null;
      this.patientReservationSector = [];

      if (this.patients.length === 1) {
        patientId = this.patients[0].Id;
        await this.findAndSetTextOthersReservation(patientId);
      }

      const report =
        await this.orientationService.getOrientationAdmissionReportPdf(
          this.orientation.Id,
          this.disabilityTemporal,
          +this.patientDocument,
          patientId,
          this.serviceId
        );

      if (report.ReportBase64) {
        this.pdfService.base64ToPdfPrint(report.ReportBase64);
        if (this.patientReservationSector.length === 0) {
          this.cancel();
        } else {
          this.otherReservation = true;
          this.action = false;
          setTimeout(() => {
            this.goStart();
          }, 6000);
        }
      } else {
        this.goService();
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.loadingAction = false;
    }
  }

  async printReservation() {
    try {
      this.loadingAction = true;
      let patientId = null;

      if (this.patients.length === 1) {
        patientId = this.patients[0].Id;
      }

      const report =
        await this.orientationService.getOrientationReservationReportPdf(
          this.orientation.Id,
          this.disabilityTemporal,
          +this.patientDocument,
          patientId,
          this.serviceId
        );

      this.pdfService.base64ToPdfPrint(report.ReportBase64);

      this.cancel();
    } catch (err) {
      console.log(err);
    } finally {
      this.loadingAction = false;
    }
  }

  async printDelivery() {
    try {
      this.loadingAction = true;
      let patientId = null;
      if (this.patients.length === 1) {
        patientId = this.patients[0].Id;
      }
      const report = await this.orientationService.getDeliveryReportPdf(
        this.orientation.Id,
        this.disabilityTemporal,
        +this.patientDocument,
        patientId,
        this.serviceId
      );
      this.pdfService.base64ToPdfPrint(report.ReportBase64);
      this.cancel();
    } catch (err) {
      console.log(err);
    } finally {
      this.loadingAction = false;
    }
  }

  private goStart() {
    this.selectedDayValue = null;
    this.selectedYearValue = null;
    this.selectedMonthValue = null;
    this.disabilityTemporal = false;
     this.otherReservation = false;
    this.patients = [];
    this.patientDocument = "";
    this.birthDay = "";
    this.birthMonth = "";
    this.birthYear = "";
    this.serviceId = null;
    this.block = false;
    this.document = true;
    this.birthDate = false;
    this.action = false;
    this.service = false;
    this.medicalAppointmentIds = [];
  }

  // private goBlock() {
  //   this.patients = [];
  //   this.patientDocument = "";
  //   this.birthDay = "";
  //   this.birthMonth = "";
  //   this.birthYear = "";
  //   this.block = true;
  //   this.document = false;
  //   this.birthDate = false;
  //   this.action = false;
  //   this.service = false;
  //   this.otherReservation = false;
  //   this.selectedDayValue = null;
  //   this.selectedYearValue = null;
  //   this.selectedMonthValue = null;
  //   this.serviceId = null;
  //   this.medicalAppointmentIds = [];
  // }

  private async goAction() {
    this.loadingAction = true;

    this.medicalAppointmentIds =
      this.patients && this.patients.length > 0
        ? await this.getAppointmentsByAutomaticAdmission(this.patients[0].Id)
        : [];

    if (this.medicalAppointmentIds.length === 0) {
      this.block = false;
      this.document = false;
      this.birthDate = false;
      this.loadingAction = false;
    }

    if (this.medicalAppointmentIds.length > 0) {
      this.loadingAction = false;
    } else if (
      this.orientation.DeliveryEnabled &&
      !this.orientation.AdmissionEnabled
    ) {
      this.printDelivery();
    } else if (
      !this.orientation.DeliveryEnabled &&
      this.orientation.AdmissionEnabled
    ) {
      this.printAdmission();
    }
  }

  async generateAppointmentAdmission() {
    this.loadingAction = true;
    this.medicalAppointmentIds =
      await this.admissionService.admissionByMedicalAppointmentIds(
        this.medicalAppointmentIds
      );

    for (const medicalAppointmentId of this.medicalAppointmentIds) {
      const report =
        await this.orientationService.getOrientationAutomaticAdmissionReportPdf(
          this.orientation.Id,
          medicalAppointmentId
        );

      this.pdfService.base64ToPdfPrint(report.ReportBase64);

      try {
        const reportOr = await this.admissionService.getOrderReportPdf(
          medicalAppointmentId
        );

        if (reportOr.length > 0) {
          reportOr.forEach((report) => {
            this.pdfService.base64ToPdfPrint(report.ReportBase64, "order");
          });
        }
      } catch (err) {
        console.log(err);
      }
    }

    this.loadingAction = false;
    this.cancel();
  }

  private goService() {
    this.block = false;
    this.document = false;
    this.birthDate = false;
    this.action = false;
    this.service = true;
  }

  private goBirthDate() {
    this.block = false;
    this.document = false;
    this.birthDate = true;
    this.action = false;
  }

  private goDocument() {
    this.selectedDayValue = null;
    this.selectedYearValue = null;
    this.selectedMonthValue = null;
    this.document = true;
    this.birthDate = false;
    this.action = false;
  }
}
